import { Link } from 'react-router-dom'

/**
 * 404 page for unmatched routes. Also rendered by RouterErrorPage when the
 * router throws a 404 route-error response.
 */
export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4 bg-background">
      <div className="text-center max-w-sm">
        <p className="text-6xl font-bold text-primary mb-4">404</p>
        <h1 className="text-xl font-semibold text-foreground mb-2">Page not found</h1>
        <p className="text-sm text-foreground-muted mb-6">
          This page does not exist.
        </p>
        <Link
          to="/"
          className="inline-flex items-center justify-center rounded-full bg-primary px-5 py-2 text-sm font-medium text-white hover:bg-primary-hover transition-colors"
        >
          Go to Main
        </Link>
      </div>
    </div>
  )
}

export default NotFoundPage
